import { Switch } from "@headlessui/react";
import { Icon } from "@iconify/react";
import React, { useState } from "react";
import { toast } from "react-toastify";
import UpdateHooks from "../../../Hooks/UpdateHooks";

const AdminModalForm = ({ id, doctor }) => {
  const [oneDay, setOneDay] = useState(doctor?.oneDayToggle);
  const [oneMonth, setOneMonth] = useState(doctor?.oneMonthToggle);
  const [threeMonth, setThreeMonth] = useState(doctor?.threeMonthToggle);
  const [sixMonth, setSixMonth] = useState(doctor?.sixMonthToggle);

  const handelUpdate = async (e) => {
    e.preventDefault();
    const anaglyphCost = Number(e.target?.anaglyphCost?.value);
    const oneDayPrice = Number(e.target?.oneDay?.value);
    const oneMonthPrice = Number(e.target?.oneMonth?.value);
    const threeMonthPrice = Number(e.target?.threeMonth?.value);
    const sixMonthPrice = Number(e.target?.sixMonth?.value);

    await UpdateHooks(`https://servercareseebd.careseebd.com/api/v1/user/${doctor?._id}`, {
      anaglyphCost,
      oneDay: oneDayPrice,
      oneMonth: oneMonthPrice,
      threeMonth: threeMonthPrice,
      sixMonth: sixMonthPrice,
    });
    toast.success("Package pricing configurations updated!");
  };

  const updateToggle = async (field, value) => {
    await UpdateHooks(`https://servercareseebd.careseebd.com/api/v1/user/${doctor?._id}`, {
      [field]: value,
    });
    toast.success("Duration status updated!");
  };

  return (
    <form onSubmit={handelUpdate} className="space-y-5">
      {/* Physical Accessories Cost block */}
      <div className="bg-slate-50/50 p-4 rounded-xl border border-slate-100 space-y-2">
        <label className="block text-[11px] font-bold text-slate-500 uppercase tracking-wide">
          Anaglyph Glasses Cost (Physical Shipping)
        </label>
        <div className="relative max-w-xs flex items-center border border-slate-200 rounded-xl focus-within:border-secondary focus-within:ring-2 focus-within:ring-indigo-500/20 bg-white overflow-hidden transition px-3.5 py-2">
          <span className="text-[10px] font-extrabold text-slate-400 mr-2">TK</span>
          <input
            type="number"
            name="anaglyphCost"
            className="w-full focus:outline-none text-xs font-semibold text-slate-700 bg-transparent"
            placeholder="0"
            defaultValue={doctor?.anaglyphCost || 0}
          />
        </div>
      </div>

      {/* Package Subscription List */}
      <div className="border border-slate-100 rounded-xl overflow-hidden bg-white shadow-xs">
        <div className="bg-slate-50/75 border-b border-slate-100 px-4 py-2.5 flex items-center justify-between">
          <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wide">
            Plan Duration
          </span>
          <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wide pr-10">
            Base Pricing
          </span>
        </div>

        <div className="divide-y divide-slate-100">
          {/* 1 Day Plan */}
          <div className="p-4 flex items-center justify-between gap-4">
            <div className="flex items-center gap-3.5">
              <Switch
                checked={oneDay}
                onChange={(checked) => {
                  setOneDay(checked);
                  updateToggle("oneDayToggle", checked);
                }}
                className={`${oneDay ? "bg-secondary" : "bg-slate-200"
                  } relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none`}
              >
                <span
                  aria-hidden="true"
                  className={`${oneDay ? "translate-x-5" : "translate-x-0"
                    } pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out`}
                />
              </Switch>
              <span className="text-xs font-bold text-slate-750">1 Day Access</span>
            </div>
            <div className="relative max-w-[130px] flex items-center border border-slate-200 rounded-xl focus-within:border-secondary focus-within:ring-2 focus-within:ring-indigo-500/20 bg-white overflow-hidden transition px-3 py-1.5">
              <span className="text-[10px] font-extrabold text-slate-400 mr-1.5">TK</span>
              <input
                type="number"
                name="oneDay"
                className="w-full text-right focus:outline-none text-xs font-semibold text-slate-755 bg-transparent"
                defaultValue={doctor?.oneDay || 0}
              />
            </div>
          </div>

          {/* 1 Month Plan */}
          <div className="p-4 flex items-center justify-between gap-4">
            <div className="flex items-center gap-3.5">
              <Switch
                checked={oneMonth}
                onChange={(checked) => {
                  setOneMonth(checked);
                  updateToggle("oneMonthToggle", checked);
                }}
                className={`${oneMonth ? "bg-secondary" : "bg-slate-200"
                  } relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none`}
              >
                <span
                  aria-hidden="true"
                  className={`${oneMonth ? "translate-x-5" : "translate-x-0"
                    } pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out`}
                />
              </Switch>
              <span className="text-xs font-bold text-slate-755">1 Month Access</span>
            </div>
            <div className="relative max-w-[130px] flex items-center border border-slate-200 rounded-xl focus-within:border-secondary focus-within:ring-2 focus-within:ring-indigo-500/20 bg-white overflow-hidden transition px-3 py-1.5">
              <span className="text-[10px] font-extrabold text-slate-400 mr-1.5">TK</span>
              <input
                type="number"
                name="oneMonth"
                className="w-full text-right focus:outline-none text-xs font-semibold text-slate-755 bg-transparent"
                defaultValue={doctor?.oneMonth || 0}
              />
            </div>
          </div>

          {/* 3 Month Plan */}
          <div className="p-4 flex items-center justify-between gap-4">
            <div className="flex items-center gap-3.5">
              <Switch
                checked={threeMonth}
                onChange={(checked) => {
                  setThreeMonth(checked);
                  updateToggle("threeMonthToggle", checked);
                }}
                className={`${threeMonth ? "bg-secondary" : "bg-slate-200"
                  } relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none`}
              >
                <span
                  aria-hidden="true"
                  className={`${threeMonth ? "translate-x-5" : "translate-x-0"
                    } pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out`}
                />
              </Switch>
              <span className="text-xs font-bold text-slate-755">3 Month Access</span>
            </div>
            <div className="relative max-w-[130px] flex items-center border border-slate-200 rounded-xl focus-within:border-secondary focus-within:ring-2 focus-within:ring-indigo-500/20 bg-white overflow-hidden transition px-3 py-1.5">
              <span className="text-[10px] font-extrabold text-slate-400 mr-1.5">TK</span>
              <input
                type="number"
                name="threeMonth"
                className="w-full text-right focus:outline-none text-xs font-semibold text-slate-755 bg-transparent"
                defaultValue={doctor?.threeMonth || 0}
              />
            </div>
          </div>

          {/* 6 Month Plan */}
          <div className="p-4 flex items-center justify-between gap-4">
            <div className="flex items-center gap-3.5">
              <Switch
                checked={sixMonth}
                onChange={(checked) => {
                  setSixMonth(checked);
                  updateToggle("sixMonthToggle", checked);
                }}
                className={`${sixMonth ? "bg-secondary" : "bg-slate-200"
                  } relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none`}
              >
                <span
                  aria-hidden="true"
                  className={`${sixMonth ? "translate-x-5" : "translate-x-0"
                    } pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out`}
                />
              </Switch>
              <span className="text-xs font-bold text-slate-755">6 Month Access</span>
            </div>
            <div className="relative max-w-[130px] flex items-center border border-slate-200 rounded-xl focus-within:border-secondary focus-within:ring-2 focus-within:ring-indigo-500/20 bg-white overflow-hidden transition px-3 py-1.5">
              <span className="text-[10px] font-extrabold text-slate-400 mr-1.5">TK</span>
              <input
                type="number"
                name="sixMonth"
                className="w-full text-right focus:outline-none text-xs font-semibold text-slate-755 bg-transparent"
                defaultValue={doctor?.sixMonth || 0}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Save Button */}
      <div className="pt-2 flex justify-end">
        <button
          type="submit"
          className="bg-secondary hover:bg-secondary/95 text-white font-bold py-2 px-5 rounded-xl shadow-md shadow-indigo-900/10 hover:shadow-lg transition duration-200 hover:-translate-y-0.5 active:translate-y-0 text-xs flex items-center gap-1.5 cursor-pointer"
        >
          <Icon icon="solar:diskette-bold-duotone" className="text-sm" />
          <span>Save Configurations</span>
        </button>
      </div>
    </form>
  );
};

export default AdminModalForm;
